import { FLAGS as zionFlags } from '@fs/zion-rootstech'

export { flagsConfig } from '@fs/zion-rootstech'

/**
 * Additional feature flags not yet available in @fs/zion-rootstech
 */

// Schedule calendar flag - controls which BSP calendars to fetch
// 'on' = multi-stage calendar only
// 'off' or null = main-stage + sessions (default)
export const NEW_CALENDAR_FLAG = 'rootstech_new_calendar'

// Routes Apollo Brightspot requests to the Brightspot 5 cloud host
export const BRIGHTSPOT5_FLAG = 'rootstech_brightspot5'

// Enables the new RootsTech top navigation.
export const ROOTSTECH_NAVIGATION_FLAG = 'rootstech_navigation'

// Offers Urdu in the language picker
// 'on' = Urdu is in the picker
// 'off' or null = Urdu is hidden from the picker; direct /ur URLs and account-language redirects remain possible
export const URDU_LANGUAGE_FLAG = 'rootstech_lang_urdu'

export const FLAGS = {
  ...zionFlags,
  NAVIGATION: ROOTSTECH_NAVIGATION_FLAG,
}
